import { useState } from "react";
import { setDate, subStringCourseTitle } from "../utils/helpers";
import Assign2ResultsRadio from "../components/Assign2ResultsRadio";
import Assign2InstructorInstructions from "../components/Assign2InstructorInstructions";
import { sidedSided } from "../utils/common";
import { postAssign2 } from "../../../components/Api/Post";
import { useAtom } from "jotai";
import { scannerRequestStateAtom } from "../../../components/Atoms/atoms";
import { RESET } from "jotai/utils";
import { Divider, CircularProgress, Button } from "@mui/material";

export default function Assign2(props) {
	const {
		navigate,
		token,
		ccid,
		handlePrint,
		confirmedOfficeInstructor,
		ccidString,
		handleDoneOfficeInstructor,
		editMode,
		onEditSubmit,
	} = props;

	const [state, setState] = useAtom(scannerRequestStateAtom);

	const [assign2Error, setAssign2Error] = useState(false);
	const [assign2HelpText, setAssign2HelpText] = useState(" ");
	const [errorState, setErrorState] = useState({
		booklets: false,
		sheets: false,
		sided: false,
		courseTitle: false,
		examDate: false,
		exam_type: false,
	});

	const [errorHelpText, setErrorHelpText] = useState({
		booklets: "",
		sheets: "",
		courseTitle: "",
		sided: "",
		examDate: "",
		exam_type: "",
	});

	const [loadingSubmit, setLoadingSubmit] = useState(false);

	const postAssign2Data = async () => {
		let courseTitle = state.courseTitle;
		let singleDouble = "";
		if (state.sided === "Single sided") {
			singleDouble = "single";
		} else if (state.sided === "Double sided") {
			singleDouble = "double";
		}
		let uploadVar = state.tsqs_upload === "upload" ? 1 : 0;
		const data = {
			lqnum: "1",
			hqnum: "10",
			qlen: "10",
			nkeys: "1",
			a: "3",
			b: "1",
			c: "0",
			d: "2",
			e: state.e,
			f: state.f,
			k: "7",
			l: "0",
			m: "0",
			n: "1",
			o: "0",
			p: "0",
			delivery: state.delivery,
			program: 4,
			rqdate: setDate(),
			coursetitle: subStringCourseTitle(courseTitle),
			instructor_name: state.instructorName,
			numopen: state.numOpen,
			docsize: state.docSize,
			singlesided: state.singleSided,
			userid: confirmedOfficeInstructor ? ccidString : ccid,
			email1: state.email1,
			phone: state.phone,
			speedcode: 84311,
			caddr1: state.instructorName,
			caddr2: state.department
				.trim()
				.substring(0, 40)
				.replace(/ *\([^)]*\) */g, ""),
			caddr3: state.delivery === "Courier" ? "" : state.address.substring(0, 60),
			status: "Received",
			dept: state.deptID,
			notes: state.notes,
			received: state.examDate,
			booklets: state.booklets,
			sheets: state.sheets,
			sided: singleDouble,
			tsqs_upload: uploadVar,
			exam_type: state.exam_type,
		};

		try {
			const response = await postAssign2(token, data);

			return response;
		} catch (error) {
			console.log("Error posting Assign2 data:", error);
		}
	};

	const handleAssign2Change = (event) => {
		const value = event.target.value;

		if (state[event.target.name] === value) {
			setState({ ...state, [event.target.name]: "" });
		} else {
			setState({ ...state, [event.target.name]: value });
		}
		setAssign2Error(false);
		setAssign2HelpText("");
		if (event.target.name === "booklets") {
			setErrorState((prev) => ({ ...prev, booklets: false }));
			setErrorHelpText((prev) => ({ ...prev, booklets: "" }));
		}
		if (event.target.name === "sheets") {
			setErrorState((prev) => ({ ...prev, sheets: false }));
			setErrorHelpText((prev) => ({ ...prev, sheets: "" }));
		}
		if (event.target.name === "courseTitle") {
			setErrorState((prev) => ({ ...prev, courseTitle: false }));
			setErrorHelpText((prev) => ({ ...prev, courseTitle: "" }));
		}
		if (event.target.name === "examDate") {
			setErrorState((prev) => ({ ...prev, examDate: false }));
			setErrorHelpText((prev) => ({ ...prev, examDate: "" }));
		}
		if (event.target.name === "exam_type") {
			setErrorState((prev) => ({ ...prev, exam_type: false }));
			setErrorHelpText((prev) => ({ ...prev, exam_type: "" }));
		}
	};

	const handleSubmit = async () => {
		setLoadingSubmit(true);
		if (state.tsqs_upload === "") {
			setLoadingSubmit(false);
			setAssign2HelpText("Please select a results delivery option");
			setAssign2Error(true);
		}
		if (state.booklets === "") {
			setLoadingSubmit(false);
			setErrorState((prev) => ({ ...prev, booklets: true }));
			setErrorHelpText((prev) => ({
				...prev,
				booklets: "Please enter a value",
			}));
		}
		if (state.courseTitle === "") {
			setLoadingSubmit(false);
			setErrorState((prev) => ({ ...prev, courseTitle: true }));
			setErrorHelpText((prev) => ({
				...prev,
				courseTitle: "Please enter a value",
			}));
		}
		if (state.examDate === "") {
			setLoadingSubmit(false);
			setErrorState((prev) => ({ ...prev, examDate: true }));
			setErrorHelpText((prev) => ({
				...prev,
				examDate: "Please enter a value",
			}));
		}
		if (state.exam_type !== "Midterm" && state.exam_type !== "Final") {
			setLoadingSubmit(false);
			setErrorState((prev) => ({ ...prev, exam_type: true }));
			setErrorHelpText((prev) => ({
				...prev,
				exam_type: "Please indicate if the exam is a midterm or final",
			}));
		}
		if (state.sheets === "") {
			setLoadingSubmit(false);
			setErrorState((prev) => ({ ...prev, sheets: true }));
			setErrorHelpText((prev) => ({
				...prev,
				sheets: "Please enter a value",
			}));
		} else if (
			state.tsqs_upload !== "" &&
			state.instructorName !== "" &&
			state.deptID !== "" &&
			state.email1 !== "" &&
			state.booklets !== "" &&
			state.sheets !== "" &&
			state.courseTitle !== "" &&
			state.examDate !== "" &&
			state.exam_type !== ""
		) {
			setAssign2Error(false);
			setAssign2HelpText("");
			try {
				if (!editMode) {
					const response = await postAssign2Data();
					const reqnum = response.data.reqnum;
					if (response.status !== 201) {
						throw new Error("Failed to submit Assign2 data");
					}

					await handlePrint(reqnum);
					setLoadingSubmit(false);
					if (confirmedOfficeInstructor) {
						handleDoneOfficeInstructor(false);
						// setState(RESET);

						window.location.reload();
					} else {
						setState(RESET);
						navigate("/success");
					}
				} else {
					await onEditSubmit();
				}
			} catch (error) {
				setLoadingSubmit(false);
				console.error("Error submitting Assign2 data:", error);
				setAssign2Error(true);
				alert("Error submitting Assign2 request. Please try again or contact TSQS.");
				setAssign2HelpText("An error occurred while submitting the form. Please try again.");
			}
		}
	};

	const exam_typeOptions = [
		{ key: 1, value: "Midterm" },
		{ key: 2, value: "Final" },
	];

	return (
		<div className="relative w-full">
			<div className="flex flex-col w-full gap-4 pt-8">
				{/* Exam Booklets Field */}
				<div className="flex flex-col">
					<label htmlFor="booklets" className="font-medium text-primary">
						Number of booklets:
					</label>
					<input
						type="number"
						id="booklets"
						name="booklets"
						value={state.booklets || ""}
						onChange={handleAssign2Change}
						className={`mt-1 p-2 border rounded ${
							errorState.booklets ? "border-red-500" : "border-gray-300"
						}`}
					/>
					{errorState.booklets && (
						<span className="text-red-500 text-xs mt-1">{errorHelpText.booklets}</span>
					)}
				</div>
				<Divider />

				<div className="flex flex-col">
					<label htmlFor="sheets" className="font-medium text-primary">
						Number of pages in each booklet:
					</label>
					<input
						type="number"
						id="sheets"
						name="sheets"
						value={state.sheets || ""}
						onChange={handleAssign2Change}
						className={`mt-1 p-2 border rounded ${
							errorState.sheets ? "border-red-500" : "border-gray-300"
						}`}
					/>
					{errorState.sheets && (
						<span className="text-red-500 text-xs mt-1">{errorHelpText.sheets}</span>
					)}
				</div>
				<Divider />
				<div className="flex flex-col gap-2">
					<label htmlFor="sided" className="font-medium text-primary">
						Are the sheets single or double sided?
					</label>
					<div className="flex flex-col sm:flex-row gap-2 ">
						{sidedSided.map((option) => (
							<button
								key={option.label}
								className={`flex items-center gap-2 p-2 border rounded mb-1 ${
									state.sided === option.value
										? "bg-primary text-white"
										: "bg-white border-gray-300 hover:bg-gray-50 text-gray-500"
								}`}
								onClick={() =>
									handleAssign2Change({
										target: { name: "sided", value: option.value },
									})
								}
							>
								{option.value}
							</button>
						))}
					</div>

					{errorState.qLen && (
						<span className="text-red-500 text-xs mt-1">{errorHelpText.sided}</span>
					)}
				</div>
				<Divider />

				{/* Dropdowns: Single/Double sided and Class selector */}

				<div className="flex flex-col">
					<label htmlFor="courseTitle" className="font-medium text-primary">
						Please enter the class below (e.g. MATH 100)
					</label>
					<input
						type="text"
						id="courseTitle"
						name="courseTitle"
						value={state.courseTitle || ""}
						onChange={handleAssign2Change}
						className={`mt-1 p-2 border rounded ${
							errorState.courseTitle ? "border-red-500" : "border-gray-300"
						}`}
					/>
					{errorState.courseTitle && (
						<span className="text-red-500 text-xs mt-1">{errorHelpText.courseTitle}</span>
					)}
				</div>
				<Divider />
				<div className="flex flex-col">
					<label htmlFor="examDate" className="font-medium text-primary">
						What day and time do you expect to drop off the exam?
					</label>
					<input
						type="datetime-local"
						id="examDate"
						name="examDate"
						value={state.examDate || ""}
						onChange={handleAssign2Change}
						className={`mt-1 p-2 border rounded ${
							errorState.examDate ? "border-red-500" : "border-gray-300"
						}`}
					/>
					{errorState.examDate && (
						<span className="text-red-500 text-xs mt-1">{errorHelpText.examDate}</span>
					)}
				</div>
				<Divider />
				<div className="flex flex-col gap-2">
					<label htmlFor="exam_type" className="font-medium text-primary">
						Is the exam a midterm or a final?
					</label>
					<div className="flex flex-col sm:flex-row gap-2 ">
						{exam_typeOptions.map((option) => (
							<button
								key={option.key}
								className={`flex items-center gap-2 p-2 border rounded mb-1 ${
									state.exam_type === option.value
										? "bg-primary text-white"
										: "bg-white border-gray-300 hover:bg-gray-50 text-gray-500"
								}`}
								onClick={() =>
									handleAssign2Change({
										target: { name: "exam_type", value: option.value },
									})
								}
							>
								{option.value}
							</button>
						))}
					</div>

					{errorState.exam_type && (
						<span className="text-red-500 text-xs mt-1">{errorHelpText.exam_type}</span>
					)}
				</div>
				<Divider />
				{/* Results Delivery Option */}
				<div className="">
					<Assign2ResultsRadio
						value={state.tsqs_upload}
						onChange={handleAssign2Change}
						name="tsqs_upload"
						error={assign2Error}
						helpText={assign2HelpText}
					/>
				</div>

				{/* Instructor Instructions */}

				<Assign2InstructorInstructions upload={state.tsqs_upload} />

				{/* Submit Button */}
				<Button
					variant="contained"
					color="primary"
					disabled={loadingSubmit}
					onClick={handleSubmit}
					className="w-full"
				>
					{loadingSubmit ? (
						<CircularProgress size={24} color="inherit" />
					) : editMode ? (
						"Update Request"
					) : (
						"Submit"
					)}
				</Button>
			</div>
		</div>
	);
}
